import React from "react";

const styles ={
    display: "flex",
    justifyContent: "center",
    fontSize: "1.3rem",
    fontWeight: "bold"
}
export default function Loading({ children }) {
  return <div style={styles}>{children}</div>;
}
